export const ORIENTATIONS = Object.freeze({
  LANDSCAPE: 'landscape',
  PORTRAIT: 'portrait',
})
